export default __webpack_public_path__ + "static/relive-f4c6a14145a480a1b932b767ba152c7e.svg";